<template>
  <tabs class="ut-px-0" gacategory="Lead Overview">
    <tab name="all" :selected="true">
      <transition-fade>
        <lead-cohorts-table
          v-if="cohorts"
          gacategory="Lead Overview"
          :cohort="cohorts[leadCohortBracketType.all]"
          :bracket="leadCohortBracketType.all"
        />
        <loading-spinner v-else />
      </transition-fade>
    </tab>

    <tab name="0 to 30 days">
      <lead-cohorts-table
        v-if="cohorts"
        gacategory="Lead Overview"
        :cohort="cohorts[leadCohortBracketType.upTo30]"
        :bracket="leadCohortBracketType.upTo30"
      />
    </tab>

    <tab name="31 to 60 days">
      <lead-cohorts-table
        v-if="cohorts"
        gacategory="Lead Overview"
        :cohort="cohorts[leadCohortBracketType.upTo60]"
        :bracket="leadCohortBracketType.upTo60"
      />
    </tab>

    <tab name="61 to 90 days">
      <lead-cohorts-table
        v-if="cohorts"
        gacategory="Lead Overview"
        :cohort="cohorts[leadCohortBracketType.upTo90]"
        :bracket="leadCohortBracketType.upTo90"
      />
    </tab>

    <tab name="91+ days">
      <lead-cohorts-table
        v-if="cohorts"
        gacategory="Lead Overview"
        :cohort="cohorts[leadCohortBracketType.above90]"
        :bracket="leadCohortBracketType.above90"
      />
    </tab>
  </tabs>
</template>

<script>
import Tab from '@oa-vue/tab/Tab.vue';
import Tabs from '@/components/LeadTabs.vue';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';
import LeadCohortsTable from '@/components/LeadCohorts/LeadCohortsTable.vue';
import LeadCohortBracketType from '@/Mapper/LeadCohortBracketType';
import TransitionFade from '@/components/TransitionFade.vue';

export default {
  name: 'LeadCohortsNav',
  components: {
    Tabs,
    Tab,
    LeadCohortsTable,
    LoadingSpinner,
    TransitionFade,
  },
  props: {
    cohorts: { required: true },
  },
  data() {
    return {
      leadCohortBracketType: LeadCohortBracketType,
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
